import { useEffect } from "react";
import LegalPageLayout, { LegalHeading } from "./LegalPageLayout";

const CONTACT_EMAIL = "info@phillyfreeway.shop";

export default function PrivacyPolicy() {
  useEffect(() => {
    document.title = "Privacy Policy | Philadelphia Freeway";
  }, []);

  return (
    <LegalPageLayout title="Privacy Policy" effectiveDate="August 1, 2026">
      <p>
        This Privacy Policy explains how the Philadelphia Freeway website (the
        "Site") handles information you share when you visit or sign up for
        anniversary updates. By using the Site, you agree to the terms of this
        Policy.
      </p>

      <section>
        <LegalHeading>Information We Collect</LegalHeading>
        <p>
          The only personal information the Site actively collects from you is
          the email address you voluntarily submit through the anniversary
          signup form. When you submit that form, we store your email address
          together with a submission timestamp and a small internal tag noting
          which page the signup came from (for example, the updates section on
          the homepage). We do not ask for, and do not knowingly collect, your
          name, phone number, mailing address, payment information, or any
          other personal detail through the signup form.
        </p>
      </section>

      <section>
        <LegalHeading>Why We Collect It</LegalHeading>
        <p>
          Your email address is used solely to send you news, event details,
          release announcements, and updates related to the Philadelphia
          Freeway 23rd Anniversary Collection. We do not sell, rent, or share
          your email address with third parties for their own marketing.
        </p>
      </section>

      <section>
        <LegalHeading>How It Is Stored</LegalHeading>
        <p>
          Subscriber records are stored in a private database used only by the
          Philadelphia Freeway team. Access is restricted to authorized
          operators and is protected by a server-side administrative
          credential; the credential is never exposed to visitors or embedded
          in the website's public code.
        </p>
      </section>

      <section>
        <LegalHeading>Unsubscribing</LegalHeading>
        <p>
          You can ask to be removed from the list at any time by emailing{" "}
          <a href={`mailto:${CONTACT_EMAIL}`} className="text-[#F4C10A] underline underline-offset-2 hover:text-[#FFD22C]">
            {CONTACT_EMAIL}
          </a>{" "}
          with the subject line "unsubscribe". Your address will be removed
          from the subscriber list, and we will stop sending you anniversary
          updates.
        </p>
      </section>

      <section>
        <LegalHeading>Cookies and Analytics</LegalHeading>
        <p>
          The Site uses only the browser storage required to remember whether
          you have already seen the welcome overlay during your current
          browsing session. It does not run any advertising or user-tracking
          cookies of its own. If your browser or a third-party service
          integrated by our hosting provider adds analytics, those are governed
          by their own privacy notices, which you can review in your browser
          settings.
        </p>
      </section>

      <section>
        <LegalHeading>Security Limitations</LegalHeading>
        <p>
          We take reasonable steps to protect the information you share with
          us. However, no method of transmission over the internet or
          electronic storage is perfectly secure, and we cannot guarantee
          absolute security. You acknowledge that any information shared with
          the Site is submitted at your own risk.
        </p>
      </section>

      <section>
        <LegalHeading>Policy Updates</LegalHeading>
        <p>
          We may update this Privacy Policy from time to time to reflect
          changes in our practices or applicable law. When we do, we will
          revise the effective date at the top of this page. Continued use of
          the Site after an update means you accept the revised Policy.
        </p>
      </section>

      <section>
        <LegalHeading>Contact</LegalHeading>
        <p>
          Questions about this Privacy Policy or about the information you
          have shared with us can be sent to{" "}
          <a href={`mailto:${CONTACT_EMAIL}`} className="text-[#F4C10A] underline underline-offset-2 hover:text-[#FFD22C]">
            {CONTACT_EMAIL}
          </a>
          .
        </p>
      </section>
    </LegalPageLayout>
  );
}
